import React, { useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

import DefaultFooter from "examples/Footers/SimpleFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import footerRoutes from "footer.routes";
import routes from "routes";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import one from "assets/numbers/Number 1.png";
import two from "assets/numbers/Number 2.png";
import three from "assets/numbers/Number 3.png";
import four from "assets/numbers/Number 4.png";
import five from "assets/numbers/Number 5.png";
import six from "assets/numbers/Number 6.png";
import seven from "assets/numbers/Number 7.png";
import eight from "assets/numbers/Number 8.png";
import nine from "assets/numbers/Number 9.png";

function NumerologyCalculator() {
  const [birthDate, setBirthDate] = useState(dayjs(new Date()));
  const [result, setResult] = useState("");
  const numberImages = [undefined, one, two, three, four, five, six, seven, eight, nine];
  // Doğum tarihinden sayıları toplar ve tek basamağa indirir
  const calculateNumerology = (date) => {
    const sum = date
      .split("-")
      .join("")
      .split("")
      .reduce((acc, curr) => acc + parseInt(curr), 0);
    const finalResult = sum
      .toString()
      .split("")
      .reduce((acc, curr) => acc + parseInt(curr), 0);
    return finalResult;
  };

  function getNumberString(rakam) {
    const rakamlar = ["Sıfır", "Bir", "İki", "Üç", "Dört", "Beş", "Altı", "Yedi", "Sekiz", "Dokuz"];

    if (rakam < 0 || rakam > 9 || isNaN(rakam)) {
      return "Geçersiz rakam";
    }

    return rakamlar[rakam];
  }
  const getContentOfNumber = (description, title, image, number) => {
    return (
      <Grid container spacing={3} alignItems="center" sx={{ mb: { xs: 6, md: 0 } }}>
        <Grid item xs={12} md={5} ml={{ xs: 0, lg: "auto" }}>
          <MKBox p={2}>
            <MKBox
              component="img"
              src={image}
              alt={title}
              width="100%"
              borderRadius="xl"
              maxHeight="37.5rem"
            />
          </MKBox>
        </Grid>
        <Grid item xs={12} md={7} mr={{ xs: 0, lg: "auto" }} position="relative">
          <MKTypography
            component="h6"
            variant="button"
            opacity={0.7}
            textTransform="uppercase"
            fontWeight="bold"
          >
            {getNumberString(number)}
          </MKTypography>
          <MKTypography
            variant="h1"
            fontWeight="bold"
            sx={{
              fontSize: ({ typography: { d3, d4 } }) => ({
                xs: d4.fontSize,
                lg: d3.fontSize,
              }),
            }}
          >
            {title}
          </MKTypography>
          <MKTypography variant="body1" my={3}>
            {description}
          </MKTypography>
        </Grid>
      </Grid>
    );
  };
  // Yorum yapma fonksiyonu
  const interpretNumerology = (number) => {
    switch (number) {
      case 1:
        return getContentOfNumber(
          "1 sayısı, liderlik ve bağımsızlıkla sıkça ilişkilendirilir. Bu sayı, doğal liderlik yeteneklerini, girişimciliği ve kararlılığı temsil eder. Liderlik, bir grubu veya organizasyonu yönlendirme ve etkileme yeteneğidir. 1 sayısına sahip kişiler genellikle liderlik rollerinde kendilerini rahat hissederler ve başkalarını motive etme yeteneğine sahiptirler. Bu liderlik yetenekleri, doğal olarak insanları etkileme ve yönlendirme yeteneğiyle birleşir. Kararlılık ve azim, 1 sayısının diğer önemli özellikleridir. Bu kişiler genellikle hedeflerine odaklanır ve onlara ulaşmak için gerekli adımları atmaktan çekinmezler. Bağımsızlık da 1 sayısıyla sıkça ilişkilendirilir. Bu sayı, bireysellik ve kendi yolunu çizme arzusunu temsil eder. 1 sayısına sahip kişiler genellikle kendi başlarına karar alabilme yeteneğine sahiptirler ve bağımsız düşünme eğilimindedirler. Bağımsızlık, genellikle risk almayı ve yeni deneyimler yaşamayı da içerir. Bu kişiler, kendi fikirlerini ve değerlerini korumak konusunda kararlıdırlar ve dış etkenlerden etkilenmeden kendi yolculuklarını takip etmeye isteklidirler. 1 sayısının temsil ettiği liderlik ve bağımsızlık özellikleri, kişinin yaşamında önemli bir rol oynar. Bu özellikler, kişinin başarılarını etkileyebilir ve onlara hedeflerine ulaşma konusunda yardımcı olabilir. Ancak, liderlik ve bağımsızlık, aşırıya kaçıldığında da olumsuz sonuçlar doğurabilir. Örneğin, aşırı rekabetçilik veya bencil davranışlar, ilişkilerde sorunlara neden olabilir. Bu nedenle, 1 sayısına sahip kişilerin bu özellikleri dengelemesi ve başkalarıyla işbirliği yapma yeteneklerini geliştirmesi önemlidir.",
          "Liderlik ve Bağımsızlık",
          numberImages[number],
          number
        );
      case 2:
        return getContentOfNumber(
          "2 sayısı, denge ve işbirliğiyle sıkça ilişkilendirilir. Bu sayı, uyumlu bir yaşam tarzını ve ilişkilerde dengeyi temsil eder. Denge, hayatın farklı alanlarında dengeyi koruma yeteneğidir. 2 sayısına sahip kişiler genellikle dengeli bir yaşam sürmeyi tercih ederler ve farklı alanlarda dengeyi sağlamak için çaba gösterirler. Bu, kişinin iş, aile, arkadaşlar ve hobiler arasında denge kurmasını içerir. İşbirliği de 2 sayısıyla sıkça ilişkilendirilir. Bu sayı, başkalarıyla uyum içinde çalışma yeteneğini ve işbirliği yapma becerisini temsil eder. 2 sayısına sahip kişiler genellikle başkalarıyla etkili bir şekilde iletişim kurabilir ve grup çalışmalarında aktif rol alabilirler. İşbirliği, kişinin farklı bakış açılarına saygı göstermesini ve başkalarıyla uyum içinde hareket etmesini gerektirir. Bu özellik, iş ilişkileri, aile ilişkileri ve arkadaşlık ilişkileri gibi çeşitli alanlarda önemlidir. 2 sayısının temsil ettiği denge ve işbirliği özellikleri, kişinin yaşamında dengeyi sağlamasına ve başkalarıyla uyum içinde çalışmasına yardımcı olabilir. Ancak, bu özelliklerin aşırıya kaçması da olumsuz sonuçlar doğurabilir. Örneğin, aşırı uyumlu olmak veya başkalarının ihtiyaçlarına aşırı derecede odaklanmak, kişinin kendi ihtiyaçlarını göz ardı etmesine neden olabilir. Bu nedenle, 2 sayısına sahip kişilerin dengeyi koruma ve işbirliği yapma yeteneklerini dengelemesi önemlidir.",
          "Denge ve İşbirliği",
          numberImages[2],
          2
        );
      case 3:
        return getContentOfNumber(
          "3 sayısı, yaratıcılık ve iletişimle sıkça ilişkilendirilir. Bu sayı, hayal gücü ve yaratıcı yeteneklerin ifadesiyle ilgilidir. Yaratıcılık, yeni fikirlerin oluşturulması ve sanatsal ifadenin keşfiyle ilgilidir. 3 sayısına sahip kişiler genellikle yaratıcı düşünceye sahiptirler ve hayatlarında sanat, müzik, yazı veya diğer yaratıcı alanlara ilgi duyarlar. Bu kişiler, kendilerini ifade etmek için çeşitli yollar ararlar ve yaratıcı projelerde yer almayı severler. İletişim de 3 sayısıyla sıkça ilişkilendirilir. Bu sayı, etkili bir şekilde iletişim kurma yeteneği ve sosyal becerileri temsil eder. 3 sayısına sahip kişiler genellikle iletişimde yeteneklidirler ve başkalarıyla kolayca etkileşime girebilirler. İfade etme yetenekleri yüksektir ve duygularını ve düşüncelerini açıkça ifade etmekte zorlanmazlar. Bu kişiler, sosyal ortamlarda aktif olmayı ve yeni insanlarla tanışmayı severler.",
          "Yaratıcılık ve İletişim",
          numberImages[3],
          3
        );
      case 4:
        return getContentOfNumber(
          "4 sayısı, sabır ve pratiklikle sıkça ilişkilendirilir. Bu sayı, uzun vadeli hedeflere ulaşmak için gereken kararlılık ve disiplini temsil eder. Sabır, zorluklarla başa çıkmak ve hedeflere ulaşmak için gereken dayanıklılık ve azmi ifade eder. 4 sayısına sahip kişiler genellikle sabırlıdırlar ve uzun vadeli planlar yapmaktan çekinmezler. Zorluklarla karşılaştıklarında pes etmek yerine, çözüm bulmaya ve ilerlemeye odaklanırlar. Pratiklik de 4 sayısıyla sıkça ilişkilendirilir. Bu sayı, düzenli bir yaşam tarzını ve işleri planlama yeteneğini temsil eder. Pratiklik, kişinin işlerini sistemli bir şekilde yönetmesine ve sorunları çözme yeteneğine sahip olmasını gerektirir. 4 sayısına sahip kişiler genellikle düzenli bir rutin ve yapılandırılmış bir yaklaşımı tercih ederler. Bu, işlerini planlama ve organizasyon becerileriyle uyumlu bir şekilde çalışırken, etkin bir şekilde ilerlemelerine yardımcı olur.",
          "Disiplin ve Sabır",
          numberImages[4],
          4
        );
      case 5:
        return getContentOfNumber(
          "5 sayısı, özgürlük ve macera ile sıkça ilişkilendirilir. Bu sayı, değişim ve yenilik arayışını temsil eder. Özgürlük, kısıtlamaları ve sınırları aşma arzusuyla ilişkilendirilir. 5 sayısına sahip kişiler genellikle rutinden hoşlanmazlar ve özgürce hareket etmekten keyif alırlar. Değişim ve çeşitlilik arayışı, hayatlarında çeşitli deneyimlere açık olduklarını gösterir. Macera da 5 sayısıyla sıkça ilişkilendirilir. Bu sayı, yeni deneyimler yaşama arzusunu ve keşfetme isteğini ifade eder. Macera, kişinin hayatına heyecan ve tutku katan farklı deneyimlerin peşinde koşma arzusunu temsil eder. 5 sayısına sahip kişiler genellikle risk almayı ve farklı kültürleri ve yerleri keşfetmeyi severler. Bu, hayatlarında çeşitli deneyimlerin ve maceraların izini sürmelerini sağlar.",
          "Özgürlük ve Macera",
          numberImages[5],
          5
        );
      case 6:
        return getContentOfNumber(
          "6 sayısı, sorumluluk ve sevgiyle sıkça ilişkilendirilir. Bu sayı, aileye ve topluma karşı sorumluluk duygusunu ve sevgi dolu ilişkileri temsil eder. Sorumluluk, kişinin kendisine ve çevresine karşı olan taahhütlerini yerine getirme yeteneğini ifade eder. 6 sayısına sahip kişiler genellikle aile, arkadaşlar ve toplum için önemli bir rol oynamaya isteklidirler. Bu, onların başkalarına yardım etme ve destekleme konusunda doğal bir eğilime sahip olduklarını gösterir. Sevgi de 6 sayısıyla sıkça ilişkilendirilir. Bu sayı, şefkat ve sevgi dolu ilişkileri ifade eder. Sevgi, insanların birbirine karşı derin bir bağlılık hissetmelerini ve birlikte olma arzusunu temsil eder. 6 sayısına sahip kişiler genellikle sevdikleriyle derin ve anlamlı ilişkiler kurarlar. Bu, onların sevgi dolu ve anlayışlı davranışlarıyla ilişkilerinde uyumu sağladıklarını gösterir.",
          "Sorumluluk ve Sevgi",
          numberImages[6],
          6
        );
      case 7:
        return getContentOfNumber(
          "7 sayısı, bilgelik ve derinlikle sıkça ilişkilendirilir. Bu sayı, içsel keşif ve manevi büyümeyle ilgili olanı temsil eder. Bilgelik, derin anlayış ve içsel bilgiyi ifade eder. 7 sayısına sahip kişiler genellikle derin düşüncelere sahip olurlar ve içsel keşif ve araştırma konularında ilgilenirler. Bu, onların hayatlarında bilgi ve anlayış arayışı içinde olduklarını gösterir. Derinlik de 7 sayısıyla sıkça ilişkilendirilir. Bu sayı, konuları derinlemesine anlama ve analiz etme yeteneğini temsil eder. Derinlik, kişinin olayları ve kavramları yüzeyde değil, daha derin bir düzeyde anlamasını ifade eder. 7 sayısına sahip kişiler genellikle konuları derinlemesine analiz ederler ve bilgiyi daha geniş bir bağlamda anlamaya çalışırlar. Bu, onların düşünme tarzlarının ve zihinsel kapasitelerinin derinliğini gösterir.",
          "İçsel Keşif ve Derinlik",
          numberImages[7],
          7
        );
      case 8:
        return getContentOfNumber(
          "8 sayısı, başarı ve güçle sıkça ilişkilendirilir. Bu sayı, maddi ve sosyal başarı için çalışma arzusunu ve güçlü liderlik yeteneklerini temsil eder. Başarı, hedeflere ulaşma ve maddi veya sosyal açıdan başarılı olma arzusunu ifade eder. 8 sayısına sahip kişiler genellikle hırslıdırlar ve kendilerini iş ve kariyer hedeflerine adamışlardır. Bu, onların liderlik yeteneklerini ve iş dünyasında etkili olma arzusunu gösterir. Güç de 8 sayısıyla sıkça ilişkilendirilir. Bu sayı, güçlü iradeyi, maddi bolluğu ve liderlik yeteneklerini ifade eder. Güç, kişinin kontrolü elinde tutma ve başkalarını yönlendirme yeteneğini ifade eder. 8 sayısına sahip kişiler genellikle güçlü bir iradeye sahiptirler ve hedeflerine ulaşmak için kararlılıkla çalışırlar. Bu, onların liderlik pozisyonlarında etkili olma ve başkalarını motive etme yeteneklerini gösterir.",
          "Başarı ve Güç",
          numberImages[8],
          8
        );
      case 9:
        return getContentOfNumber(
          "9 sayısı, duyarlılık, anlayış ve evrensel sevgiyle sıkça ilişkilendirilir. Bu sayı, derin duyguları ve insanlara karşı içten bir ilgiyi temsil eder. Duyarlılık, başkalarının duygularını anlama ve onlara karşı empati kurma yeteneğidir. 9 sayısına sahip kişiler genellikle etrafındaki insanların duygusal ihtiyaçlarına duyarlıdır ve onları desteklemek için çaba gösterirler. Empati, kişinin başkalarının hislerini anlamasını ve onlara karşı saygılı bir şekilde davranmasını sağlar. Evrensel sevgi de 9 sayısıyla sıkça ilişkilendirilir. Bu, herkesi kucaklayan, koşulsuz sevgiyi temsil eder. 9 sayısına sahip kişiler genellikle evrensel sevgi ve şefkat duygularını güçlü bir şekilde hissederler. Bu, insanlığa ve dünyaya karşı derin bir bağlılık hissetmek anlamına gelir. Bu kişiler, insanların birbirine karşı anlayışlı ve saygılı olması gerektiğine inanırlar ve dünyada barış ve uyumun teşvik edilmesini desteklerler. 9 sayısının temsil ettiği duyarlılık ve evrensel sevgi özellikleri, kişinin yaşamında derin bir anlam ve bağlantı hissetmesine yardımcı olabilir. Bu özellikler, kişinin başkalarına yardım etme ve dünyada pozitif bir etki yaratma arzusunu teşvik edebilir. Ancak, bu özelliklerin aşırıya kaçması da olumsuz sonuçlar doğurabilir. Örneğin, aşırı duyarlılık, kişinin kendi ihtiyaçlarını ihmal etmesine neden olabilir veya aşırı duygusal tepkiler, ilişkilerde sorunlara yol açabilir. Bu nedenle, 9 sayısına sahip kişilerin duyarlılık ve sevgi dolu davranışlarını dengelemesi ve kendi sınırlarını koruması önemlidir. Duyarlılık ve evrensel sevgi, 9 sayısının temel özellikleridir ve bu özellikler genellikle kişinin yaşam yolculuğunu şekillendirir. Bu sayıya sahip kişiler genellikle insanların ihtiyaçlarını anlama ve onlara yardım etme konusunda doğal bir eğilime sahiptirler. Bu özellikler, kişinin topluma ve insanlığa karşı derin bir sorumluluk duygusu geliştirmesine yardımcı olabilir ve onları olumlu bir şekilde etkileyen önemli bir rol oynar.",
          "Duyarlılık ve Evrensel Sevgi",
          numberImages[9],
          9
        );
      default:
        return "Bu sayı hakkında yorum yapamıyorum.";
    }
  };

  // Form submit işlemi
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(birthDate);
    const result = calculateNumerology(birthDate.$d.toISOString().substring(0, 10));
    setResult(interpretNumerology(result));
  };
  const [activeTab, setActiveTab] = useState(0);

  const handleTabType = (event, newValue) => setActiveTab(newValue);

  const getContent = () => {
    if (activeTab === 0) {
      return (
        <Container>
          {/* <MKTypography variant="h1" mb={1}>
            Doğum Tarihi Numeroloji Yorumlayıcı
          </MKTypography> */}
          <MKTypography variant="body" sx={{ marginBottom: 1 }}>
            Doğum tarihinizi girerek kişisel numeroloji yorumunuzu alın!
          </MKTypography>
          <MKBox
            onSubmit={handleSubmit}
            width="100%"
            component="form"
            method="post"
            autocomplete="off"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <DatePicker
              fullWidth
              mb={1}
              label="Doğum Tarihi"
              value={birthDate}
              onChange={(newValue) => setBirthDate(newValue)}
            />
            <br />
            <MKButton type="submit" variant="gradient" color="info" fullWidth>
              Yorumla
            </MKButton>
          </MKBox>
          {result && <p>{result}</p>}
        </Container>
      );
    } else {
      return <></>;
    }
  };
  return (
    <>
      <MKBox bgColor="white" shadow="sm" py={0.25}>
        <DefaultNavbar routes={routes} transparent relative center sticky />
      </MKBox>
      <MKBox component="section" py={12}>
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={12}
            justifyContent="center"
            mx="auto"
            textAlign="center"
            pb={6}
          >
            <MKTypography variant="h2" mb={2}>
              Numeroloji
            </MKTypography>
            <MKTypography variant="body1" color="text" mb={1}>
              Numeroloji, sayıların sembolik anlamlarını ve etkilerini inceleyen bir inanç
              sistemidir. İnsan yaşamını, kişiliğini, davranışlarını ve olayları sayılarla
              ilişkilendirir. Genellikle bir kişinin doğum tarihi ve ismi üzerinden hesaplamalar
              yapılır.
            </MKTypography>
            <MKTypography variant="body1" color="text" mb={1}>
              Numerolojide kullanılan temel yöntemlerden biri &rdquo;doğum tarihi
              numerolojisi&rdquo;dir. Bu yöntemde, bir kişinin doğum tarihi üzerinden belirli
              sayılar elde edilir ve bu sayılar yorumlanarak kişinin özellikleri ve yaşam yolculuğu
              hakkında bilgi edinilir.
            </MKTypography>
            <MKTypography variant="body1" color="text" mb={1}>
              Bir başka yaygın yöntem ise &rdquo;isim numerolojisi&rdquo;dir. Bu yöntemde, bir
              kişinin isminin her harfi belirli bir sayıya karşılık gelir. Bu sayılar toplanarak bir
              &rdquo;isim sayısı&rdquo; elde edilir ve bu sayı da yorumlanarak kişinin özellikleri
              hakkında bilgi verir.
            </MKTypography>
            <MKTypography variant="body1" color="text" mb={1}>
              Her bir sayının belirli bir anlamı vardır ve farklı kombinasyonlarla yorumlanabilir.
              Örneğin, bir kişinin doğum tarihinin sayıları toplanarak yaşam yolculuğunu ifade eden
              bir ana sayı elde edilebilir. Bu sayı, kişinin yaşamındaki potansiyel güçlü ve zayıf
              yönleri belirtmek için yorumlanabilir.
            </MKTypography>
          </Grid>
          <AppBar position="static">
            <Tabs value={activeTab} onChange={handleTabType}>
              <Tab label="Doğum Tarihi Numeroloji" />
              <Tab label="İsim Numeroloji" />
            </Tabs>
          </AppBar>
          {getContent()}
        </Container>
      </MKBox>

      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default NumerologyCalculator;
